import { styled } from '@mui/material/styles';
import ButtonComponent from '../../../components/ButtonComponent';

const ResetPasswordButton = styled(ButtonComponent)(({ theme }) => ({
  width: '100%',
  justifyContent: 'center',
  paddingLeft: theme.spacing(3),
  paddingRight: theme.spacing(3),
  paddingTop: theme.spacing(1.5),
  paddingBottom: theme.spacing(1.5),
  textTransform: 'none',
}));

export default ResetPasswordButton;
